import { defaultTo } from 'lodash';
import { Model, IModel, ModelRecord } from './Model';
import { makeObservable, observable } from 'mobx';
export interface IStateModel extends IModel {
  stateId: number;
  name: string;
  abbreviation: string;
  taxValue: number;
  hasPrescriptionProductTax: boolean;
  hasClinicServiceTax: boolean;
  hasLicenseFeeTax: boolean;
  hasVetcoPrescriptionTax: boolean;
  zoneOffset: number;
  visitNote: string;
}

export class StateModel extends Model implements ModelRecord<IStateModel> {
  @observable stateId: number;
  @observable name: string;
  @observable abbreviation: string;
  @observable taxValue: number;
  @observable hasPrescriptionProductTax: boolean;
  @observable hasClinicServiceTax: boolean;
  @observable hasLicenseFeeTax: boolean;
  @observable hasVetcoPrescriptionTax: boolean;
  @observable zoneOffset: number;
  @observable visitNote: string;

  constructor(params?: Partial<IStateModel>) {
    super(params);
    this.stateId = defaultTo(params?.stateId, 0);
    this.name = defaultTo(params?.name, '');
    this.abbreviation = defaultTo(params?.abbreviation, '');
    this.taxValue = defaultTo(params?.taxValue, 0);
    this.hasPrescriptionProductTax = defaultTo(
      params?.hasPrescriptionProductTax,
      false,
    );
    this.hasClinicServiceTax = defaultTo(params?.hasClinicServiceTax, false);
    this.hasVetcoPrescriptionTax = defaultTo(
      params?.hasVetcoPrescriptionTax,
      false,
    );
    this.hasLicenseFeeTax = defaultTo(params?.hasLicenseFeeTax, false);
    this.zoneOffset = defaultTo(params?.zoneOffset, 0);
    this.visitNote = defaultTo(params?.visitNote, '');
    makeObservable(this);
  }
}
